import { RateDto } from '../config/fileConfig'
import { BaseTierDto, isActiveTier, isBaseUserTier } from '../config/finance/financeConfig'
import { FileRateType } from '../context/GlobalContext'
import { parseDate } from './dateHelper'

// Resolves the billable sales rate for a user on a date from a file's rate settings.
// Shared by the time mutation form and the invoice-approval move dialog, so both derive
// the same rate from the same /file/{id}/rate response.
export function resolveRate(rates: RateDto<BaseTierDto>, userId: string, date: string): string {
    switch (rates.fileRateType) {
        case FileRateType.File:
            return rates.rate
        case FileRateType.UserTier:
            return (
                (rates.tiers || [])
                    .filter(tier => isActiveTier(tier, parseDate(date)))
                    .filter(tier => isBaseUserTier(tier))
                    .find(tier => tier.userId === userId)?.salesRate || '0.00'
            )
        case FileRateType.PartyTier:
            return (rates.tiers || []).find(tier => isActiveTier(tier, parseDate(date)))?.salesRate || '0.00'
    }
}
